export default __webpack_public_path__ + "static/media/user_placeholder_white.12b5979f.svg";